
    import './styles.scoped.css';
    export default {
  "root-status": "awsui_root-status_wxf7i_113l8_5",
  "group-status": "awsui_group-status_wxf7i_113l8_9"
};
  